/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ProjectNotFoundEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const projectNotFoundEntryPoint: EntryPoint<ProjectNotFoundEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<ProjectNotFoundEntryPointComponent>(
			/* webpackChunkName: "async-project-not-found", jiraSpaEntry: "async-project-not-found" */ './ProjectNotFoundOrNoPermissionErrorPageWithAnalytics.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	});
